import React from 'react';

const DikeySettings = React.memo(({
  activeTypeTab,
  dikeyExtras,
  setDikeyExtras,
  dikeyPvcExtras,
  setDikeyPvcExtras,
  dikeyStorExtras,
  setDikeyStorExtras,
  isFonListCollapsed,
  setIsFonListCollapsed,
  newDikeyFonName,
  setNewDikeyFonName,
  editingDikeyFonName,
  setEditingDikeyFonName,
  handleSaveSettings,
  isSavingSettings
}) => {
  const isPerde = activeTypeTab === 'dikeyPerde';
  const isPvc = activeTypeTab === 'dikeyPvc';
  const isStor = activeTypeTab === 'dikeyStor';

  const extras = isPerde ? dikeyExtras : isPvc ? dikeyPvcExtras : dikeyStorExtras;
  const setExtras = isPerde ? setDikeyExtras : isPvc ? setDikeyPvcExtras : setDikeyStorExtras;

  return (
    <>
      <div className="settings-card" style={{ marginBottom: '20px' }}>
        <div className="settings-card-title">
          <i className="fas fa-cogs"></i>
          <h4>Motor Ayarları ({activeTypeTab === 'dikeyPerde' ? 'Dikey Perde' : activeTypeTab === 'dikeyPvc' ? 'Dikey PVC' : 'Dikey Stor'})</h4>
          <button className="btn-save" onClick={() => handleSaveSettings()} disabled={isSavingSettings}>
            {isSavingSettings ? '...' : 'Kaydet'}
          </button>
        </div>
        <div className="settings-grid">
          <div className="form-group" style={{ marginBottom: 0 }}>
            <label>Motor Döviz Kuru</label>
            <select value={extras.motorCurrency} onChange={(e) => setExtras(p => ({ ...p, motorCurrency: e.target.value }))}>
              <option value="USD">USD</option>
              <option value="EUR">EUR</option>
              <option value="TRY">TRY</option>
            </select>
          </div>
          <div className="form-group" style={{ marginBottom: 0 }}>
            <label>Motor Ücreti</label>
            <input type="number" value={extras.motorPrice} onChange={(e) => setExtras(p => ({ ...p, motorPrice: e.target.value }))} />
          </div>
        </div>
      </div>

      {isPerde && (
        <div className="settings-card" style={{ marginBottom: '20px' }}>
          <div
            className="settings-header clickable"
            onClick={() => setIsFonListCollapsed(!isFonListCollapsed)}
            style={{ 
              padding: '15px 20px', 
              display: 'flex', 
              justifyContent: 'space-between', 
              alignItems: 'center',
              borderBottom: !isFonListCollapsed ? '1px solid #e2e8f0' : 'none'
            }}
          >
            <div className="settings-title" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <i className="fas fa-arrows-alt-v" style={{ color: '#b04309' }}></i>
              <h4 style={{ margin: 0 }}>Dikey Perde Fon Ayarları</h4>
            </div>
            <i className={`fas fa-chevron-${isFonListCollapsed ? 'down' : 'up'}`} style={{ color: '#64748b' }}></i>
          </div>

          {!isFonListCollapsed && (
            <div className="settings-content" style={{ padding: '20px' }}>
              <div className="pricing-setup-card" style={{ 
                background: '#f8fafc', 
                borderRadius: '12px', 
                padding: '20px', 
                marginBottom: '20px', 
                border: '1px solid #e2e8f0',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                flexWrap: 'wrap',
                gap: '15px'
              }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                  <div style={{ color: '#b04309', fontSize: '1.2rem' }}>
                    <i className="fas fa-coins"></i>
                  </div>
                  <label style={{ fontWeight: '600', color: '#1e293b', margin: 0 }}>Dikey Perde Fon Ücreti (m2)</label>
                </div>
                <div style={{ display: 'flex', gap: '10px' }}>
                  <input 
                    type="number" 
                    value={dikeyExtras.fon} 
                    onChange={(e) => setDikeyExtras(p => ({ ...p, fon: e.target.value }))} 
                    style={{ width: '120px', padding: '8px', borderRadius: '6px', border: '1px solid #cbd5e1' }}
                  />
                  <button className="btn-save" onClick={() => handleSaveSettings()} disabled={isSavingSettings} style={{ padding: '8px 20px' }}>
                    {isSavingSettings ? '...' : 'Kaydet'}
                  </button>
                </div>
              </div>

              <div className="settings-column">
                <h5 style={{ marginBottom: '15px', color: '#1e293b', display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <i className="fas fa-list"></i> Fon İsimleri Listesi
                </h5>
                <div className="list-add-form" style={{ display: 'flex', gap: '10px', marginBottom: '15px' }}>
                  <input
                    type="text"
                    placeholder="Yeni Fon Adı (Örn: Fon 1)"
                    value={newDikeyFonName}
                    onChange={(e) => setNewDikeyFonName(e.target.value)}
                    style={{ flex: 1, padding: '8px', borderRadius: '6px', border: '1px solid #cbd5e1' }}
                  />
                  <button 
                    onClick={() => {
                      if (!newDikeyFonName) return;
                      const newList = [...(dikeyExtras.fonList || []), newDikeyFonName];
                      setDikeyExtras({ ...dikeyExtras, fonList: newList });
                      setNewDikeyFonName('');
                      handleSaveSettings({ dikeyFonList: newList });
                    }}
                    style={{ background: '#b04309', color: 'white', border: 'none', padding: '8px 15px', borderRadius: '6px', cursor: 'pointer' }}
                  >
                    <i className="fas fa-plus"></i>
                  </button>
                </div>

                <div className="settings-list-container" style={{ maxHeight: '300px', overflowY: 'auto', border: '1px solid #e2e8f0', borderRadius: '8px' }}>
                  {(!dikeyExtras.fonList || dikeyExtras.fonList.length === 0) ? (
                    <div style={{ padding: '20px', textAlign: 'center', color: '#64748b' }}>Liste boş</div>
                  ) : (
                    <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                      {dikeyExtras.fonList.map((item, index) => (
                        <li key={index} style={{ padding: '10px 15px', borderBottom: index === dikeyExtras.fonList.length - 1 ? 'none' : '1px solid #f1f5f9', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                          {editingDikeyFonName.index === index ? (
                            <div style={{ display: 'flex', gap: '10px', flex: 1 }}>
                              <input
                                type="text"
                                value={editingDikeyFonName.value}
                                onChange={(e) => setEditingDikeyFonName({ ...editingDikeyFonName, value: e.target.value })}
                                autoFocus
                                style={{ flex: 1, padding: '5px 10px', borderRadius: '4px', border: '1px solid #b04309' }}
                              />
                              <button onClick={() => {
                                const newList = [...dikeyExtras.fonList];
                                newList[index] = editingDikeyFonName.value;
                                setDikeyExtras({ ...dikeyExtras, fonList: newList });
                                handleSaveSettings({ dikeyFonList: newList });
                                setEditingDikeyFonName({ index: null, value: '' });
                              }} style={{ color: '#059669', background: 'none', border: 'none', cursor: 'pointer' }}><i className="fas fa-check"></i></button>
                              <button onClick={() => setEditingDikeyFonName({ index: null, value: '' })} style={{ color: '#ef4444', background: 'none', border: 'none', cursor: 'pointer' }}><i className="fas fa-times"></i></button>
                            </div>
                          ) : (
                            <>
                              <span style={{ color: '#334155', fontWeight: '500' }}>{item}</span>
                              <div style={{ display: 'flex', gap: '10px' }}>
                                <button onClick={() => setEditingDikeyFonName({ index, value: item })} style={{ color: '#64748b', background: 'none', border: 'none', cursor: 'pointer' }}><i className="fas fa-edit"></i></button>
                                <button onClick={() => {
                                  const newList = dikeyExtras.fonList.filter((_, i) => i !== index);
                                  setDikeyExtras({ ...dikeyExtras, fonList: newList });
                                  handleSaveSettings({ dikeyFonList: newList });
                                }} style={{ color: '#ef4444', background: 'none', border: 'none', cursor: 'pointer' }}><i className="fas fa-trash-alt"></i></button>
                              </div>
                            </>
                          )}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </>
  );
});

export default DikeySettings;
